import { Link } from 'react-router-dom';
import { ROUTE_NAMES } from '@tsgecart/config';

/**
 * Reached when `GET /api/v1/auth/me` succeeds but the required role isn't
 * present, or when it comes back as an AUTHORIZATION_ERROR (account exists
 * but its status isn't `active` -- locked/suspended/disabled/deleted). The
 * backend deliberately never distinguishes these cases in its response
 * (see docs/security-model.md "Frontend guards are UX only" /
 * authentication-architecture.md), so this page's copy stays equally
 * generic -- it never says "you're suspended" vs. "you're not an admin",
 * which would let a client enumerate account state it has no business
 * knowing.
 */
export function ForbiddenPage() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-3 bg-white p-8 text-center">
      <h1 className="text-2xl font-semibold text-gray-900">Access denied</h1>
      <p className="max-w-sm text-gray-500">
        You don&apos;t have access to this page. If you believe this is a mistake, contact an
        administrator.
      </p>
      <Link to={ROUTE_NAMES.home} className="bg-brand text-brand-foreground rounded-full px-4 py-2 text-sm font-semibold">
        Back to home
      </Link>
    </main>
  );
}
